<template>
  <div>
    <template v-for="article in articles" :key="article.id">
      <slot v-bind="{ article }"></slot>
    </template>
    <div v-inview="loadnext" v-if="!$presenterInfo?.editable">&nbsp;</div>
  </div>
</template>
<script>
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import store from 'nette-base-module/js/store'

export default {
  data () {
    return {
      articles: [ this.$presenter.article ]
    }
  },
  directives: {
    inview: {
      mounted (el, binding) {
        el.pagingOnScroll = () => {
          const rect = el.getBoundingClientRect()
          const inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )

          if (inView) {
            window.removeEventListener('scroll', el.pagingOnScroll)
            binding.value().then(() => {
              if (el.pagingOnScroll) {
                window.addEventListener('scroll', el.pagingOnScroll)
              }
            })
          }
        }
        window.addEventListener('scroll', el.pagingOnScroll)
        // el.pagingOnScroll()
      },
      unmounted (el) {
        if (el.pagingOnScroll) {
          window.removeEventListener('scroll', el.pagingOnScroll)
          delete el.pagingOnScroll
        }
      }
    },
  },
  methods: {
    async loadnext () {
      if (this.$controls.nextArticles.articles.length) {
        this.articles.push(...this.$controls.nextArticles.articles)
      }

      const paginator = this.$controls['nextArticles-p'].paginator
      const response = await NetteAjax.ajax({
          url: paginator.page < paginator.lastPage ? paginator.url.replace('123456789', paginator.page + 1) : this.articles[(this.articles.length-1)].link,
          off: ['cache', 'vue-render']
      })

      // append new articles to end
      store.dispatch('nette/updateControl', {
          controlName: 'nextArticles',
          data: response.$controls.nextArticles
      })

      // update paginatoru
      store.dispatch('nette/updateControl', {
          controlName: 'nextArticles-p',
          data: response.$controls['nextArticles-p']
      })
    }
  }
}
</script>